import { render, staticRenderFns } from "./get-app-dropdown.vue?vue&type=template&id=522b63d0&scoped=true&lang=pug&"
import script from "./get-app-dropdown.vue?vue&type=script&lang=js&"
export * from "./get-app-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./get-app-dropdown.vue?vue&type=style&index=0&id=522b63d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522b63d0",
  null
  
)

component.options.__file = "get-app-dropdown.vue"
export default component.exports